<template>
  <div class="menuFrame">
    <loading :active.sync="isLoading"></loading>

    <div id="track">
      <div class="d-flex justify-content-between">
        <div>
          <a href="/ExhibitorServiceTW/">Exhibition List</a><span>/</span>
          <em name="Exhibition"></em> <span>/</span>
          <a href="javascript: history.back()">Booth Events</a>
          <span>/</span>Edit Booth Event
        </div>
        <div>
          <span class="bold">Account :</span>
          <span> {{ UserId }}</span>
        </div>
      </div>
    </div>
    <!-- track end -->
    <!-- article -->
    <article>
      <div class="contentBox">
        <div>
          <h1>Edit Booth Event</h1>
          <p class="my-3">&nbsp;</p>

          <div>
            <div class="alert">
              <div>
                <i class="fas fa-exclamation-circle mr-1"></i>
                All booth events organized and conducted by exhibitors must
                comply with the laws and regulations of the Republic of China
                (Taiwan) or the host country/region of the exhibition. Events
                shall not involve or include any content deemed immoral,
                obscene, violent, gambling-related, infringing, or otherwise
                unlawful.
              </div>
              <div class="mt-1">
                <i class="fas fa-exclamation-circle mr-1"></i>
                The Organizer provides only the exhibition website platform and
                assumes no responsibility or guarantee regarding the content,
                quality, or legality of events conducted at individual booths.
              </div>
              <div class="mt-1">
                <i class="fas fa-exclamation-circle mr-1"></i>
                In the event of any improper or non-compliant events, the
                Organizer reserves the right to immediately suspend such events
                or revoke the exhibitor’s participation.
              </div>
            </div>
          </div>
        </div>
        <p class="my-3">&nbsp;</p>

        <form
          name="_method"
          id="form"
          enctype="multipart/form-data"
          @submit.prevent="AddNewEvent"
        >
          <input type="hidden" name="RegNo" value="" />
          <!-- left -->
          <!-- PC版圖片顯示 -->

          <!-- PC版圖片顯示 -->

          <div class="proLeft PcDevice">
            <label class="inputFile">
              <div class="squareThumb pointer ImgHoverStyle">
                <img :src="modelSrc" class="img-fluid" />
              </div>

              <p class="my-3">&nbsp;</p>
              <span name="showName" class="nowrap"></span>
              <input
                type="file"
                name="ProImg"
                accept=".jpg,.jpeg,.webp"
                @change="uploadNewImgPC($event)"
              />
              <p class="divider"></p>
              <div class="d-flex justify-content-around">
                <div>
                  <p class="align_c">
                    <span class="btnStyle btnGray">Select</span>
                  </p>
                </div>
                <div v-if="modelSrc !== OImgSrc">
                  <p class="align_c">
                    <span class="btnStyle btnRed" @click.prevent="resetImg"
                      >Reset
                    </span>
                  </p>
                </div>
              </div>
            </label>
            <div class="uploadAlert">
              <p class="italic">File Size：Maximum 3MB</p>
              <p class="italic">File Format：JPG、WEBP</p>
              <p class="italic">Pixel Size：Minimum 500 x 500 Pixel</p>
            </div>
          </div>

          <!-- 行動版圖片顯示 -->

          <div class="proLeft MbDevice">
            <label class="inputFile pointer">
              <div class="mb-3">
                <img :src="modelSrc" class="img-fluid" />
              </div>
              <p class="my-3">&nbsp;</p>
              <span name="showName" class="nowrap"></span>
              <input
                type="file"
                name="ProImg"
                accept=".jpg,.jpeg,.webp"
                @change="uploadNewImgMb($event)"
              />
              <p class="divider"></p>
              <div class="d-flex justify-content-around">
                <div>
                  <p class="align_c">
                    <span class="btnStyle btnGray">Select</span>
                  </p>
                </div>
                <div v-if="modelSrc !== OImgSrc">
                  <p class="align_c">
                    <span class="btnStyle btnRed" @click.prevent="resetImg"
                      >Reset
                    </span>
                  </p>
                </div>
              </div>
            </label>
            <div class="uploadAlert">
              <p class="italic">File Size：Maximum 3MB</p>
              <p class="italic">File Format：JPG、WEBP</p>
              <p class="italic">Pixel Size：Minimum 500 x 500 Pixel</p>
            </div>
          </div>

          <!-- left end -->
          <!-- right -->
          <div class="proRight">
            <div>
              <p class="formTitle">Display</p>
              <div class="form-check-inline">
                <div class="formstatus">
                  <input
                    class="form-check-input"
                    type="radio"
                    name="Radios"
                    id="yes"
                    :value="true"
                    v-model="EventArchive"
                  />
                  <label class="form-check-label" for="yes"> Show</label>
                </div>
                <div class="ml-2">
                  <input
                    class="form-check-input"
                    type="radio"
                    name="Radios"
                    id="no"
                    :value="false"
                    v-model="EventArchive"
                  />
                  <label class="form-check-label" for="no"> Hide </label>
                </div>
              </div>
              <p class="my-3">&nbsp;</p>
              <p class="formTitle">Event Name <span class="red">*</span></p>
              <div class="langTip">
                <input
                  type="text"
                  name="eEventName"
                  class="textStyle maxText"
                  maxlength="100"
                  required
                  placeholder=""
                  v-model="eEventName"
                />
                <span>EN</span>
              </div>
              <p class="divider"></p>

              <div class="langTip">
                <input
                  type="text"
                  name="EventName"
                  class="textStyle maxText"
                  maxlength="50"
                  placeholder=""
                  v-model="EventName"
                />
                <span>CN</span>
              </div>

              <p class="my-3">&nbsp;</p>

              <p class="formTitle">Event Time <span class="red">*</span></p>
              <div v-if="EventDatesList[0]" class="d-flex align-items-center">
                <!-- 勾選：啟用這天 -->
                <div class="form-check">
                  <input
                    class="form-check-input"
                    type="checkbox"
                    :id="'day1-check'"
                    v-model="day1.enabled"
                  />
                  <label
                    class="form-check-label"
                    :for="'day1-check'"
                    style="width: 85px; font-weight: 600"
                  >
                    {{ EventDatesList[0] }}
                  </label>
                </div>

                <div class="d-flex align-items-center ml-2">
                  <div>Start Time：</div>
                  <vue-timepicker
                    :minute-interval="10"
                    v-model="day1.startTime"
                    format="HH:mm"
                    placeholder="HH:mm"
                    :disabled="!day1.enabled"
                    :class="{ 'is-invalid': day1.enabled && !isDay1Valid }"
                  ></vue-timepicker>

                  <div class="ml-2">End Time：</div>
                  <vue-timepicker
                    :minute-interval="10"
                    v-model="day1.endTime"
                    format="HH:mm"
                    placeholder="HH:mm"
                    :disabled="!day1.enabled"
                    :class="{ 'is-invalid': day1.enabled && !isDay1Valid }"
                  ></vue-timepicker>
                </div>
              </div>
              <div v-if="EventDatesList[1]" class="d-flex align-items-center">
                <div class="form-check">
                  <input
                    class="form-check-input"
                    type="checkbox"
                    :id="'day2-check'"
                    v-model="day2.enabled"
                  />
                  <label
                    class="form-check-label"
                    :for="'day2-check'"
                    style="width: 85px; font-weight: 600"
                  >
                    {{ EventDatesList[1] }}
                  </label>
                </div>

                <div class="d-flex align-items-center ml-2">
                  <div>Start Time：</div>
                  <vue-timepicker
                    :minute-interval="10"
                    v-model="day2.startTime"
                    format="HH:mm"
                    placeholder="HH:mm"
                    :disabled="!day2.enabled"
                    :class="{ 'is-invalid': day2.enabled && !isDay2Valid }"
                  ></vue-timepicker>

                  <div class="ml-2">End Time：</div>
                  <vue-timepicker
                    :minute-interval="10"
                    v-model="day2.endTime"
                    format="HH:mm"
                    placeholder="HH:mm"
                    :disabled="!day2.enabled"
                    :class="{ 'is-invalid': day2.enabled && !isDay2Valid }"
                  ></vue-timepicker>
                </div>
              </div>
              <div v-if="EventDatesList[2]" class="d-flex align-items-center">
                <div class="form-check">
                  <input
                    class="form-check-input"
                    type="checkbox"
                    :id="'day3-check'"
                    v-model="day3.enabled"
                  />
                  <label
                    class="form-check-label"
                    :for="'day3-check'"
                    style="width: 85px; font-weight: 600"
                  >
                    {{ EventDatesList[2] }}
                  </label>
                </div>

                <div class="d-flex align-items-center ml-2">
                  <div>Start Time：</div>
                  <vue-timepicker
                    :minute-interval="10"
                    v-model="day3.startTime"
                    format="HH:mm"
                    placeholder="HH:mm"
                    :disabled="!day3.enabled"
                    :class="{ 'is-invalid': day3.enabled && !isDay3Valid }"
                  ></vue-timepicker>

                  <div class="ml-2">End Time：</div>
                  <vue-timepicker
                    :minute-interval="10"
                    v-model="day3.endTime"
                    format="HH:mm"
                    placeholder="HH:mm"
                    :disabled="!day3.enabled"
                    :class="{ 'is-invalid': day3.enabled && !isDay3Valid }"
                  ></vue-timepicker>
                </div>
              </div>
              <div v-if="EventDatesList[3]" class="d-flex align-items-center">
                <div class="form-check">
                  <input
                    class="form-check-input"
                    type="checkbox"
                    :id="'day4-check'"
                    v-model="day4.enabled"
                  />
                  <label
                    class="form-check-label"
                    :for="'day4-check'"
                    style="width: 85px; font-weight: 600"
                  >
                    {{ EventDatesList[3] }}
                  </label>
                </div>

                <div class="d-flex align-items-center ml-2">
                  <div>Start Time：</div>
                  <vue-timepicker
                    :minute-interval="10"
                    v-model="day4.startTime"
                    format="HH:mm"
                    placeholder="HH:mm"
                    :disabled="!day4.enabled"
                    :class="{ 'is-invalid': day4.enabled && !isDay4Valid }"
                  ></vue-timepicker>

                  <div class="ml-2">End Time：</div>
                  <vue-timepicker
                    :minute-interval="10"
                    v-model="day4.endTime"
                    format="HH:mm"
                    placeholder="HH:mm"
                    :disabled="!day4.enabled"
                    :class="{ 'is-invalid': day4.enabled && !isDay4Valid }"
                  ></vue-timepicker>
                </div>
              </div>
              <div v-if="EventDatesList[4]" class="d-flex align-items-center">
                <div class="form-check">
                  <input
                    class="form-check-input"
                    type="checkbox"
                    :id="'day5-check'"
                    v-model="day5.enabled"
                  />
                  <label
                    class="form-check-label"
                    :for="'day5-check'"
                    style="width: 85px; font-weight: 600"
                  >
                    {{ EventDatesList[4] }}
                  </label>
                </div>

                <div class="d-flex align-items-center ml-2">
                  <div>Start Time：</div>
                  <vue-timepicker
                    :minute-interval="10"
                    v-model="day5.startTime"
                    format="HH:mm"
                    placeholder="HH:mm"
                    :disabled="!day5.enabled"
                    :class="{ 'is-invalid': day5.enabled && !isDay5Valid }"
                  ></vue-timepicker>

                  <div class="ml-2">End Time：</div>
                  <vue-timepicker
                    :minute-interval="10"
                    v-model="day5.endTime"
                    format="HH:mm"
                    placeholder="HH:mm"
                    :disabled="!day5.enabled"
                    :class="{ 'is-invalid': day5.enabled && !isDay5Valid }"
                  ></vue-timepicker>
                </div>
              </div>

              <p class="clear"></p>

              <p class="my-3">&nbsp;</p>
              <p class="formTitle">
                Event Description (English) <span class="red">*</span>
              </p>
              <textarea
                name="eEventDesc"
                rows="4"
                class="maxText textStyle"
                placeholder=""
                v-model="eEventDesc"
                maxlength="500"
                required
              ></textarea>
              <p class="grayBG">Max. 500 characters</p>

              <p class="my-3">&nbsp;</p>
              <p class="formTitle">Event Description (Chinese)</p>
              <textarea
                name="EventDesc"
                rows="4"
                class="maxText textStyle"
                placeholder=""
                v-model="EventDesc"
                maxlength="200"
              ></textarea>
              <p class="grayBG">Max. 200 characters</p>

              <p class="my-3">&nbsp;</p>

              <p class="formTitle">Event Disclaimer (English)</p>
              <textarea
                name="eProWarning"
                rows="4"
                class="maxText textStyle"
                placeholder=""
                v-model="eEventRemind"
                maxlength="400"
              ></textarea>

              <p class="grayBG">Max. 400 characters</p>

              <p class="my-3">&nbsp;</p>
              <p class="formTitle">Event Disclaimer (Chinese)</p>
              <textarea
                name="ProWarning"
                rows="4"
                class="maxText textStyle"
                placeholder=""
                v-model="EventRemind"
                maxlength="200"
              ></textarea>

              <p class="grayBG">Max. 200 characters</p>
            </div>
          </div>
          <!-- right end -->
          <p class="clear"></p>
          <p class="PcDevice my-4">&nbsp;</p>
          <div class="text-center PcDevice mb-4">
            <button class="btn btn-lg btn-primary mr-4" type="submit">
              Confirm
            </button>
            <button
              class="btn btn-lg btn-secondary"
              @click.prevent="backEventPage"
            >
              Back
            </button>
          </div>

          <div class="text-center mb-4 MbDevice">
            <button class="btn btn-primary mr-2" type="submit">Confirm</button>
            <button class="btn btn-secondary" @click.prevent="backEventPage">
              Back
            </button>
          </div>
        </form>

        <!-- 桌機板裁切工具 Modal  -->
        <div id="cropImagePop" class="modal fade" tabindex="-1" role="dialog">
          <div class="modal-dialog modal-xl" role="document">
            <div class="modal-content">
              <div class="modal-header d-flex justify-content-between">
                <div class="modal-title" style="font-size: 25px">
                  <div class="d-flex align-self-center">
                    <div class="mr-3">
                      <img
                        src="../../../assets/images/cropImg.png"
                        width="30px"
                      />
                    </div>
                    <div style="font-size: 25px">Edit Image</div>
                  </div>
                </div>
                <div
                  type="button"
                  class="close"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  <span aria-hidden="true">&times;</span>
                </div>
              </div>
              <div class="modal-body">
                <div class="row">
                  <div class="col-sm-8">
                    <div class="CropBoxStyle">
                      <vue-cropper
                        ref="cropper"
                        :img="option.img"
                        :output-size="option.size"
                        :output-type="option.outputType"
                        :info="true"
                        :full="option.full"
                        :fixed="fixed"
                        :can-move="option.canMove"
                        :can-move-box="option.canMoveBox"
                        :fixed-box="option.fixedBox"
                        :original="option.original"
                        :auto-crop="option.autoCrop"
                        :auto-crop-width="option.autoCropWidth"
                        :auto-crop-height="option.autoCropHeight"
                        :center-box="option.centerBox"
                        :high="option.high"
                        :max-img-size="option.max"
                        :fixed-number="fixedNumber"
                        :enlarge="option.enlarge"
                        :infoTrue="option.infoTrue"
                        :mode="option.mode"
                        @real-time="realTime"
                      >
                      </vue-cropper>
                    </div>

                    <div class="d-flex justify-content-between mt-3 mx-3">
                      <div>
                        <button @click="rotateLeft" class="btn btn-info">
                          Rotate Left
                        </button>
                        <button @click="rotateRight" class="btn btn-info ml-2">
                          Rotate Right
                        </button>
                        <button
                          @click="changeScale(1)"
                          class="btn btn-info ml-2"
                        >
                          +
                        </button>
                        <button
                          @click="changeScale(-1)"
                          class="btn btn-info ml-2"
                        >
                          -
                        </button>
                      </div>
                      <div>
                        <button
                          @click="refreshCrop"
                          class="btn btn-outline-info ml-5"
                        >
                          Reset
                        </button>
                      </div>
                    </div>
                  </div>
                  <div class="col-sm-4">
                    <div :style="previewStyle1" class="ImgPreCrop">
                      <div :style="previews.div">
                        <img :src="previews.url" :style="previews.img" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <hr />
              <div class="modal-footer">
                <div>
                  <button
                    type="button"
                    id="cropImageBtn"
                    class="btn btn-primary btn-lg mr-2"
                    @click="OutputPC()"
                  >
                    Crop
                  </button>
                  <button
                    type="button"
                    class="btn btn-lg btn-secondary"
                    data-dismiss="modal"
                  >
                    Close
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- 行動版裁切工具 Modal  -->
        <div
          class="modal fade"
          id="cropperMb"
          tabindex="-1"
          role="dialog"
          aria-labelledby="exampleModalCenterTitle"
          aria-hidden="true"
          data-backdrop="static"
          data-keyboard="false"
        >
          <div
            class="modal-dialog modal-sm modal-dialog-centered"
            role="document"
          >
            <div class="modal-content">
              <div class="modal-body">
                <p>
                  &middot; Automatically resize your image into square image.
                </p>
                <p>
                  &middot; If you need to crop or edit your image, please use
                  the computer to upload your image.
                </p>
              </div>

              <div class="modal-footer">
                <button
                  type="button"
                  id="cropperMb"
                  class="btn btn-sm btn-primary"
                  @click="OutputMb()"
                >
                  OK
                </button>
              </div>
            </div>
          </div>
        </div>

        <div v-if="showImg" class="CropBoxStyle">
          <vue-cropper
            ref="cropper"
            :img="option.img"
            :output-size="option.size"
            :output-type="option.outputType"
            :info="true"
            :full="option.full"
            :fixed="fixed"
            :can-move="option.canMove"
            :can-move-box="option.canMoveBox"
            :fixed-box="option.fixedBox"
            :original="option.original"
            :auto-crop="option.autoCrop"
            :auto-crop-width="option.autoCropWidth"
            :auto-crop-height="option.autoCropHeight"
            :center-box="option.centerBox"
            :high="option.high"
            :max-img-size="option.max"
            :fixed-number="fixedNumber"
            :enlarge="option.enlarge"
            :infoTrue="option.infoTrue"
            :mode="option.mode"
          >
          </vue-cropper>
        </div>
      </div>
    </article>
  </div>
</template>

<script>
import $ from "jquery";
import axios from "axios";

export default {
  metaInfo() {
    return {
      title: "Edit Booth Event - Chan Chao Exhibitor's Online Service System",
    };
  },

  data() {
    return {
      EventID: "",
      currentPage: 1,

      UserId: "",
      showImg: false,
      CSRF_Token: "",
      RegNo: "",
      EventArchive: true,
      EventName: "",
      EventDesc: "", //活動說明
      eEventName: "",
      eEventDesc: "", //活動說明 EN
      eEventRemind: "",
      modelSrc: "",
      OImgSrc: "", // 原始圖片

      previews: {},
      previewStyle1: {},
      lang: "tw",

      option: {
        img: "", // 裁剪图片的地址V
        max: 9999, //限制图片最大宽度和高度
        enlarge: 1, //图片根据截图框输出比例倍数
        mode: "contain",

        centerBox: false, // 截图框是否被限制在图片里面
        canMove: true, //上传图片是否可以移动
        infoTrue: true,

        fixedBox: true, // 固定截图框大小 不允许改变
        canMoveBox: false, // 截图框能否拖动
        autoCrop: true, // 是否默认生成截图框
        // 只有自动截图开启 宽度高度才生效
        autoCropWidth: 500, // 默认生成截图框宽度
        autoCropHeight: 500,

        full: true, //是否输出原图比例的截图，X匯出等比例(長型就匯長型)
        high: true, //是否按照设备的dpr 输出等比例图片，X匯出等比例(長型就匯長型)
        original: true, // 上传图片按照原始比例渲染

        size: 1, //裁剪生成图片的质量V
        outputType: "webp", // 裁剪生成图片的格式V
      },

      fixed: true, // 是否开启截图框宽高固定比例
      fixedNumber: [1, 1], // 截图框的宽高比例

      hasImgfile: false,

      LocalExh: true,
      EventDatesList: [],

      // 你原本的
      day1: { enabled: false, startTime: "", endTime: "" },
      day2: { enabled: false, startTime: "", endTime: "" },
      day3: { enabled: false, startTime: "", endTime: "" },
      day4: { enabled: false, startTime: "", endTime: "" },
      day5: { enabled: false, startTime: "", endTime: "" },

      EventDatesRaw: [],

      EventRemind: "",
      BoothEventTime: [],
    };
  },

  computed: {
    // 基本驗證：若啟用，需有 start/end 且 start < end
    isDay1Valid() {
      if (!this.day1.enabled) return true;
      if (!this.day1.startTime || !this.day1.endTime) return false;
      // 'HH:mm' 直接字串比較也可行，保險起見轉分鐘比較
      const toMin = (t) => {
        const [h, m] = t.split(":").map(Number);
        return h * 60 + m;
      };
      return toMin(this.day1.startTime) < toMin(this.day1.endTime);
    },
    isDay2Valid() {
      if (!this.day2.enabled) return true;
      if (!this.day2.startTime || !this.day2.endTime) return false;
      // 'HH:mm' 直接字串比較也可行，保險起見轉分鐘比較
      const toMin = (t) => {
        const [h, m] = t.split(":").map(Number);
        return h * 60 + m;
      };
      return toMin(this.day2.startTime) < toMin(this.day2.endTime);
    },
    isDay3Valid() {
      if (!this.day3.enabled) return true;
      if (!this.day3.startTime || !this.day3.endTime) return false;
      // 'HH:mm' 直接字串比較也可行，保險起見轉分鐘比較
      const toMin = (t) => {
        const [h, m] = t.split(":").map(Number);
        return h * 60 + m;
      };
      return toMin(this.day3.startTime) < toMin(this.day3.endTime);
    },
    isDay4Valid() {
      if (!this.day4.enabled) return true;
      if (!this.day4.startTime || !this.day4.endTime) return false;
      // 'HH:mm' 直接字串比較也可行，保險起見轉分鐘比較
      const toMin = (t) => {
        const [h, m] = t.split(":").map(Number);
        return h * 60 + m;
      };
      return toMin(this.day4.startTime) < toMin(this.day4.endTime);
    },

    isDay5Valid() {
      if (!this.day5.enabled) return true;
      if (!this.day5.startTime || !this.day5.endTime) return false;
      // 'HH:mm' 直接字串比較也可行，保險起見轉分鐘比較
      const toMin = (t) => {
        const [h, m] = t.split(":").map(Number);
        return h * 60 + m;
      };
      return toMin(this.day5.startTime) < toMin(this.day5.endTime);
    },

    TimesForApi() {
      const days = [this.day1, this.day2, this.day3, this.day4, this.day5];
      const result = [];

      days.forEach((d, idx) => {
        const date = this.EventDatesRaw?.[idx]; // YYYY/MM/DD
        if (!date) return; // 沒有日期就跳過

        const hasTime = d.startTime || d.endTime;

        // 規則：勾選的要存；或沒勾選但有填時間也要存
        if (d.enabled || hasTime) {
          result.push({
            Date: date,
            StartTime: d.startTime || "",
            EndTime: d.endTime || "",
            Enable: !!d.enabled,
          });
        }
      });

      return result;
    },

    hasAnyDayChecked() {
      // 判斷是否有至少一天「勾選」且「有填開始/結束時間」
      const days = [this.day1, this.day2, this.day3, this.day4, this.day5];
      return days.some((day) => {
        return day.enabled && day.startTime && day.endTime;
      });
    },
  },

  methods: {
    resetImg() {
      const vm = this;
      vm.modelSrc = vm.OImgSrc;
    },

    AddNewEvent() {
      const vm = this;

      if (vm.hasAnyDayChecked) {
        const url = "/apiExhibitors/BoothEvent/";

        const isUnchangedPic =
          (vm.modelSrc || "").trim() === (vm.initialLogo || "").trim();

        const info = {
          RegNo: vm.RegNo,
          BoothEventID: vm.EventID,
          IsShow: vm.EventArchive,

          EventPic: isUnchangedPic ? "" : vm.modelSrc,
          BoothEventName: vm.EventName,
          BoothEventEName: vm.eEventName,
          BoothEventDesc: vm.EventDesc,
          BoothEventEDesc: vm.eEventDesc,
          BoothEventRemind: vm.EventRemind,
          BoothEventERemind: vm.eEventRemind,
          Times: vm.TimesForApi,
          CSRF: vm.CSRF_Token,
        };

        if (vm.modelSrc == "../../../assets/images/default.jpg") {
          alert("Must provide image, please check again！");
        } else {
          if (!vm.eEventName || !vm.eEventDesc) {
            alert(
              "Some required fields are incomplete — please check and try again！",
            );
          } else {
            axios.post(url, info).then(function (response) {
              if (response.data.Code == 200) {
                alert("Booth Event updated successfully");
                document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/en/Boothevent?no=${vm.RegNo}`;
              } else if (
                response.data.Code == 251 ||
                response.data.Code == 500
              ) {
                alert("The system is busy, please try again later.");
                document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/en/Boothevent?no=${vm.RegNo}`;
              } else if (response.data.Code == 401) {
                alert("Missing fields or invalid format.");
              } else if (response.data.Code == 402) {
                alert("Failed to save image. Please try again.");
              } else if (response.data.Code == 403) {
                alert("Invalid image format. Please use JPG, PNG, or GIF.");
              } else if (response.data.Code == 405) {
                alert("No image uploaded. Please select a file.");
              } else if (response.data.Code == 406) {
                alert("You have exceeded the maximum limit of activities.");
              } else if (response.data.Code == 404) {
                alert("404 not found！");
              }
            });
          }
        }
      } else {
        alert(
          "Please select at least one day and fill in the complete start and end times！",
        );
      }
    },

    uploadNewImgPC(e) {
      const vm = this;

      let file = e.target.files[0];

      if (!/\.(jpg|jpeg|JPG|JPEG|webp|WEBP)$/.test(e.target.value)) {
        alert("Upload file must be in JPG or WebP！");
        return false;
      }

      let reader = new FileReader();

      reader.onload = (e) => {
        const isLt5M = e.total / 1024 / 1024 < 3;

        // console.log(e)
        if (isLt5M) {
          $("#cropImagePop").modal("show");

          $("#cropImagePop").on("shown.bs.modal", function () {
            vm.option.img = window.URL.createObjectURL(
              new Blob([e.target.result]),
            );
          });
        } else {
          alert("Maximum file size : 3MB");
        }
      };

      reader.readAsArrayBuffer(file);
      e.target.value = "";
    },

    uploadNewImgMb(e) {
      const vm = this;

      //上传图片
      // this.option.img
      var file = e.target.files[0];
      if (!/\.(jpg|jpeg|JPG|JPEG|webp|WEBP)$/.test(e.target.value)) {
        alert("Upload file must be in JPG or WebP！");
        return false;
      }
      var reader = new FileReader();
      reader.readAsArrayBuffer(file);

      reader.onload = (e) => {
        const isLt5M = e.total / 1024 / 1024 < 3;

        if (isLt5M) {
          this.option.img = window.URL.createObjectURL(
            new Blob([e.target.result]),
          );
          vm.showImg = true;
          $("#cropperMb").modal("show");
        } else {
          alert("Maximum file size : 3MB");
        }
      };
      e.target.value = "";
    },

    OutputPC() {
      const vm = this;

      this.$refs.cropper.getCropData((data) => {
        // console.log(data)
        this.modelSrc = data;
        $("#cropImagePop").modal("hide");

        $("#cropImagePop").on("hidden.bs.modal", function (e) {
          vm.option.img = "/";
        });

        window.setTimeout(
          () =>
            alert(
              'After you change the event picture, please click "Confirm" to ensure the revision has been completed.',
            ),
          1000,
        );
      });
    },

    OutputMb() {
      // 输出
      const vm = this;

      this.$refs.cropper.getCropData((data) => {
        // console.log(data)
        this.modelSrc = data;
      });

      $("#cropperMb").modal("hide");
      vm.showImg = false;

      window.setTimeout(
        () =>
          alert(
            'After you change the event picture, please click "Confirm" to ensure the revision has been completed.',
          ),
        1000,
      );
    },

    realTime(data) {
      var previews = data;
      var h = 0.5;
      var w = 0.2;

      this.previewStyle1 = {
        width: previews.w + "px",
        height: previews.h + "px",
        overflow: "hidden",
        margin: "0",
        zoom: h,
      };

      this.previews = data;
    },

    rotateLeft() {
      this.$refs.cropper.rotateLeft();
    },
    rotateRight() {
      this.$refs.cropper.rotateRight();
    },

    changeScale(num) {
      num = num || 1;
      this.$refs.cropper.changeScale(num);
    },

    refreshCrop() {
      this.$refs.cropper.refresh();
    },

    backEventPage() {
      const vm = this;
      if (vm.lang == "tw") {
        document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/Boothevent?no=${vm.RegNo}`;
      } else {
        document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/en/Boothevent?no=${vm.RegNo}`;
      }
    },
  },

  created() {
    const vm = this;

    //CSRF_Token
    axios
      .get("https://www.chanchao.com.tw/apiExhibitors/CSRF_Token")
      .then((response) => {
        vm.CSRF_Token = response.data;
      });

    axios
      .get(`https://www.chanchao.com.tw/apiExhibitors/UserID`)
      .then((response) => {
        vm.UserId = response.data;
      });

    //url取出展碼
    let currentUrl = location.href;
    vm.RegNo = currentUrl.split("no=")[1].split("&")[0];
    vm.EventID = currentUrl.split("id=")[1].split("&")[0];

    if (currentUrl.split("Page=")[1]) {
      vm.currentPage = currentUrl.split("Page=")[1];
    }

    axios
      .get(
        `https://www.chanchao.com.tw/apiExhibitors/Exhibition/${vm.RegNo}?lang=en`,
      )
      .then((response) => {
        if (response.data.Code == 200) {
          let ExpoLocation = response.data.Data.ExpoLocation;

          if (ExpoLocation === "T" || ExpoLocation === null) {
            vm.LocalExh = true;
          } else {
            vm.LocalExh = false;
          }
        } else if (response.data.Code == 404) {
          // console.log('查無資料')
        } else {
          alert("The system is busy, please try again later");
        }
      });

    let url = `/apiExhibitors/BoothEvent/Info/${vm.RegNo}?BoothEventID=${vm.EventID}`;
    axios
      .get(url)
      .then(function (response) {
        console.log(response);
        if (response.data.Data) {
          vm.BoothEventTime = response.data.Data.BoothEventTime;
          vm.EventArchive = response.data.Data.IsShow;
          vm.EventName = response.data.Data.BoothEventName;
          vm.EventDesc = response.data.Data.BoothEventDesc;
          vm.EventRemind = response.data.Data.BoothEventRemind;
          vm.eEventName = response.data.Data.BoothEventEName;
          vm.eEventDesc = response.data.Data.BoothEventEDesc;
          vm.eEventRemind = response.data.Data.BoothEventERemind;

          vm.modelSrc = `${response.data.Data.EventPic}`;

          vm.OImgSrc = `${response.data.Data.EventPic}`;
          vm.initialLogo = `${response.data.Data.EventPic}`;

          // ========= B. 前台用日期列表 EventDatesList / API 用 EventDatesRaw =========
          const weekMap = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
          const showDates = [];
          const rawDates = [];

          const beginStr = response.data.Data.ExhBegin; // 可能是 "2025/11/19" 或 ISO
          const endStr = response.data.Data.ExhEnd;

          if (beginStr && endStr) {
            const begin = new Date(beginStr);
            const end = new Date(endStr);
            // 生出展期間連續日期
            for (
              let d = new Date(begin);
              d <= end;
              d.setDate(d.getDate() + 1)
            ) {
              const y = d.getFullYear();
              const m = String(d.getMonth() + 1).padStart(2, "0");
              const dd = String(d.getDate()).padStart(2, "0");
              const w = weekMap[d.getDay()];
              showDates.push(`${m}/${dd}(${w})`); // 顯示用
              rawDates.push(`${y}/${m}/${dd}`); // 給 API 用
            }
          } else if (vm.BoothEventTime.length) {
            // 沒展期，用 BoothEventTime 補：BoothEventTime.Date 是 "MM/DD"
            const thisYear = new Date().getFullYear(); // 或改成你的活動年
            vm.BoothEventTime.forEach((it) => {
              const [m, d] = (it.Date || "").split("/");
              if (!(m && d)) return;
              const ymd = `${thisYear}/${String(m).padStart(2, "0")}/${String(
                d,
              ).padStart(2, "0")}`;
              const dObj = new Date(ymd);
              const w = isNaN(dObj) ? "" : `(${weekMap[dObj.getDay()]})`;
              showDates.push(
                `${String(m).padStart(2, "0")}/${String(d).padStart(
                  2,
                  "0",
                )}${w}`,
              );
              rawDates.push(ymd);
            });
          }

          vm.EventDatesList = showDates;
          vm.EventDatesRaw = rawDates;

          // ========= C. 回填 BoothEventTime -> day1~day5 =========
          const clean = (t) => (!t || t === "00:00" ? "" : t);
          const toMMDD = (s) => {
            const p = (s || "").split("/");
            return p.length === 3
              ? `${p[1].padStart(2, "0")}/${p[2].padStart(2, "0")}` // YYYY/MM/DD -> MM/DD
              : `${(p[0] || "").padStart(2, "0")}/${(p[1] || "").padStart(
                  2,
                  "0",
                )}`; // MM/DD
          };

          // 以 MM/DD 當 key 做快查
          const byMMDD = new Map();
          vm.BoothEventTime.forEach((it) => {
            byMMDD.set(toMMDD(it.Date), {
              startTime: clean(it.StartTime),
              endTime: clean(it.EndTime),
              enabled: !!it.Enable,
            });
          });

          const days = [vm.day1, vm.day2, vm.day3, vm.day4, vm.day5];

          days.forEach((dayObj, idx) => {
            const rawDate = vm.EventDatesRaw?.[idx]; // "YYYY/MM/DD"
            if (!rawDate) return;
            const key = toMMDD(rawDate); // "MM/DD"

            const found = byMMDD.get(key);
            if (found) {
              dayObj.startTime = found.startTime; // "00:00" 轉 ""
              dayObj.endTime = found.endTime;
              dayObj.enabled = found.enabled; // 未勾選但有時間也會回填到欄位
            } else {
              dayObj.startTime = "";
              dayObj.endTime = "";
              dayObj.enabled = false;
            }
          });
        } else {
          alert(
            "Unavailable URL The URL is incorrect; you will be automatically redirected！",
          );
          document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/en/home?no=${vm.RegNo}`;
        }
      })
      .catch((err) => {
        alert(
          "Unavailable URL The URL is incorrect; you will be automatically redirected！",
        );
        document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/en/home?no=${vm.RegNo}`;
      });
  },
};
</script>

<style lang="scss">
.form-control {
  height: calc(2.2em + 0.75rem + 2px);
}

// @media screen and (min-width: 331px) and (max-width: 576px) {
//   .modal-content {
//     width: 65%;
//   }
// }

// @media screen and (max-width: 330px) {
//   .modal-content {
//     width: 60%;
//   }
// }

.modal-xl {
  max-width: 940px;
}

.modal-body {
  height: 75vh;
  overflow-y: auto;
}

.custom-control-label {
  font-size: 15px;
}

.el-collapse-item__header {
  font-size: 17px;
  font-weight: 550;
}

.vue__time-picker input.display-time {
  border: 1px solid #d2d2d2;
  width: 70px !important;
  height: 2.2em;
  padding: 0.3em 0.5em;
  font-size: 1em;

  /* 你要的修改 */
  border-radius: 3px; /* 圓潤度調高 */
  margin-bottom: 3px; /* mb-2 的效果 (大概 0.5rem ≈ 8px) */
}

.vue__time-picker {
  display: inline-block;
  position: relative;
  font-size: 1em;
  width: 70px !important;
  font-family: sans-serif;
  vertical-align: middle;
}

.grayBG {
  background: #f0f4f5;
  color: #333;
  padding: 5px 10px;
  display: inline-block;
  word-break: break-all;
  font-size: 14px;
}
</style>
